/*
 * @Author: your name
 * @Date: 2022-03-26 17:06:49
 * @LastEditTime: 2022-03-26 17:12:16
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\utils\computed\index.js
 */


import DateTimeService from './datetime-service'
export default {
    DateTimeService
}